import { createFormatDateFunction, featureEnabled } from 'utils';
import { APPOINTMENT_STATUS_FOR_COVID_19_LABEL } from '../../constants';

angular.module('bb.listing_search').component('bbAppointmentSearchTable', {
  bindings: {
    search: '<',
    sort: '<',
    serverDate: '<',
    appointments: '<',
    auth: '<',
    viewListing: '<',
    showButton: '<',
    openContactDrawer: '<',
  },
  controller: AppointmentSearchTableController,
  controllerAs: 'vm',
  template: require('./appointment_search_table.html'),
});

AppointmentSearchTableController.$inject = [
  'ModalService',
  '$route',
  '$rootScope',
  'FeedbackService',
  'ErrorService',
  'ToastService',
];
function AppointmentSearchTableController(
  ModalService,
  $route,
  $rootScope,
  FeedbackService,
  ErrorService,
  ToastService,
) {
  const vm = this;

  vm.suggestedTimeChangePermission = [
    'new',
    'confirm',
    'time_change',
    'suggested_time_change',
    'attempted',
  ];
  vm.APPOINTMENT_STATUS_FOR_COVID_19_LABEL =
    APPOINTMENT_STATUS_FOR_COVID_19_LABEL;
  vm.formatDate = (date, timezone) =>
    createFormatDateFunction('E, MMM do')(date, timezone);

  vm.openPreviewToTab = (appointmentId, listing, tab) => {
    if (!vm.isViewingAdmin() && !vm.isListingAgent(listing)) return;

    ModalService.openAppointmentModal(appointmentId, listing.id, tab).then(
      updated => {
        if (updated) $route.reload();
      },
    );
  };

  vm.openPreviewToFeedback = (appointmentId, listing) => {
    if (!vm.isViewingAdmin() && !vm.isListingAgent(listing)) return;

    ModalService.openAppointmentModal(
      appointmentId,
      listing.id,
      'feedback',
    ).then(updated => {
      if (updated) $route.reload();
    });
  };

  vm.changePreviewAppointment = appointment => {
    vm.previewAppointment = appointment;
  };

  vm.isListingAgent = listing => {
    if (listing.reps && listing.reps.some(user => user === vm.auth.id))
      return true;
    if (
      listing.hiddenReps &&
      listing.hiddenReps.some(user => user === vm.auth.id)
    )
      return true;
    return false;
  };

  vm.isViewingAdmin = () =>
    vm.auth.roles[vm.auth.role] >= vm.auth.roles.TEAM_ADMIN;

  vm.sendingReminder = new Set();

  vm.sendReminder = (appointmentId, listing) => {
    // Don't try to send more reminders if one is already sending
    // return if not authorized
    if (
      vm.sendingReminder.has(appointmentId) ||
      !(vm.isViewingAdmin() || vm.isListingAgent(listing))
    )
      return;

    vm.sendingReminder.add(appointmentId);
    FeedbackService.sendFeedbackReminder(listing.id, appointmentId)
      .then(() => {
        ToastService.add({
          message: 'Email sent!',
          type: 'success',
        });
      })
      .catch(err => {
        ErrorService.toastyHTTPErr(err);
      })
      .finally(() => {
        vm.sendingReminder.delete(appointmentId);
      });
  };

  vm.hasSupraRebrandingFeature = featureEnabled('supraRebrandingFeature', 1);
}
